exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontDiv p[data-v-65d099b8]{line-height:30px}.sorry[data-v-65d099b8]{font-size:16px;font-weight:bold;color:#333333}.fail_reason[data-v-65d099b8]{font-size:14px;color:#666666}\n", ""]);

// exports
